import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IDealRentTagType = 'deal_rent';

export interface IDealRentTag {
  type: 'deal_rent';
}

function isDealRentTag(tag: TTag): tag is IDealRentTag {
  return tag.type === 'deal_rent';
}

export const isDealRentTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const value = jsonQuery.deal_rent && jsonQuery.deal_rent.value;

    if (value) {
      return ensureSingleTagExists(tags, isDealRentTag, previousTag => ({ type: IDealRentTagType }));
    } else {
      return ensureTagNotExists(tags, isDealRentTag);
    }
  },
};
